import {
  maxDashboardWidth,
  maxHorizontalCardWidth,
  maxVerticalCardWidth
} from 'const/styles'
import styled, { css } from 'styled-components'
import query from 'syf-component-library/const/mediaQueries'
import { spacing } from 'syf-component-library/defaultTheme'
import { Inset } from 'syf-component-library/ui/spacing'
import H5 from 'syf-component-library/ui/typography/H5'
import theme from 'theme'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const DashboardContainer = styled(Inset)`
  width: 100%;

  @media ${query.greaterThanLarge} {
    max-width: ${maxDashboardWidth}px;
  }
`

export const DashboardAccountGrid = styled.div<{
  shouldShowNotificationCenter: boolean
}>`
  display: flex;
  margin: 0 auto;
  padding-bottom: ${spacing.large}px;
  justify-content: ${({ shouldShowNotificationCenter }) =>
    shouldShowNotificationCenter ? 'flex-start' : 'center'};
  flex-wrap: wrap;
  gap: ${spacing.small}px;

  @media ${query.greaterThanSmall} {
    gap: ${spacing.base}px;
    justify-content: ${({ shouldShowNotificationCenter }) =>
      shouldShowNotificationCenter ? 'flex-start' : 'center'};
  }

  @media ${query.greaterThanMedium} {
    gap: ${spacing.xlarge}px;
  }
  * {
    box-sizing: border-box;
  }
`
export const AccountManagerContainer = styled.div`
  max-width: ${maxHorizontalCardWidth}px;
  margin-bottom: ${spacing.medium}px;
  @media ${query.betweenSmallMedium} {
    margin-bottom: ${spacing.medium}px;
    max-width: ${maxVerticalCardWidth}px;
  }
`

const AccountCardMobileView = css`
  justify-items: left;
  text-align: center;
`

export const AccountManagerGrid = styled(Inset)`
  display: grid;
  grid-template-columns: auto auto;
  gap: ${spacing.small}px;
  justify-content: left;
  align-items: center;
  border-radius: 5px;
  padding: 0;

  @media ${query.lessThanMedium} {
    ${AccountCardMobileView}
    grid-template-columns: 100%;
    padding-left: ${spacing.small}px;
  }
`

export const AccountManagerText = styled(H5)`
  color: ${theme.white};
`

export const MainContainer = styled.div<{
  shouldShowNotificationCenter: boolean
}>`
  display: flex;
  justify-content: ${({ shouldShowNotificationCenter }) =>
    shouldShowNotificationCenter ? 'space-between' : 'space-around'};

  @media ${query.lessThanMedium} {
    flex-direction: column-reverse;
  }
`

export const NotificationContainer = styled.div`
  @media ${query.lessThanMedium} {
    padding-left: ${spacing.small}px;
  }
`
export const AccountsContainer = styled.div`
  flex: 2;
`
